import LinkButton from '@paperstac/ui/lib/LinkButton';
import React from 'react';

const NavLinkButton = ({ fontSize = [0, 1], mr = [0, 0, 4], ...props }) => (
  <LinkButton
    sx={{
      fontSize,
      mr,
      textTransform: 'uppercase',
      cursor: 'pointer',
    }}
    {...props}
  />
);

NavLinkButton.defaultProps = {};

NavLinkButton.displayName = 'NavLinkButton';

export default NavLinkButton;
